






import { Component, Mixins } from "vue-property-decorator";
import { ContentMixin } from "./mixins";

@Component
export default class WizardContentPatientIndicator extends Mixins(ContentMixin) {
  get patientNo(): string {
    return this.readPropertyOrDefault(s => s.attributes.patient.id, "");
  }

  get patientName(): string {
    return this.readPropertyOrDefault(s => s.attributes.patient.name, "");
  }
}
